import { Controller } from "@hotwired/stimulus"

// Replaces legacy field.js remove + hide-labels for nested form lines.
// Sets _destroy and hides the row; first visible line keeps labels when
// the list has data-hide-labels.
export default class extends Controller {
  static targets = ["line"]

  connect() {
    this.updateFirstVisible()
  }

  lineTargetConnected() {
    this.updateFirstVisible()
  }

  remove(event) {
    const button = event.target.closest('[data-nested-line-remove], [data-action*="nested-line-list#remove"]')
    if (!button) return

    event.preventDefault()

    const line = button.closest('[data-nested-line-list-target="line"]')
    if (!line) return

    const destroyInput = line.querySelector('input[name*="[_destroy]"]')
    if (destroyInput) destroyInput.value = "1"

    this.hideLine(line)
    this.updateFirstVisible()
  }

  hideLine(line) {
    line.hidden = true
    line.classList.add("hidden")
  }

  lineVisible(line) {
    return !line.hidden && !line.classList.contains("hidden")
  }

  updateFirstVisible() {
    if (!this.element.hasAttribute("data-hide-labels")) return

    this.lineTargets.forEach((line) => line.classList.remove("nested-line-show-labels"))

    const firstVisible = this.lineTargets.find((line) => this.lineVisible(line))
    if (firstVisible) firstVisible.classList.add("nested-line-show-labels")
  }
}
